/* bvm-richiesta.js — MODULO RICHIESTE NOSTRO (24/10/2026, sessione C), unico per tutte le pagine che avevano un modulo Globo.
   Va con snippets/bvm-richiesta.liquid. Lavora SOLO sugli attributi data-bvm-richiesta-* e sui name dei campi, mai sulle classi: la
   grafica nuova potrà cambiarle liberamente.
   · lo snippet non ha <form>: i campi hanno form="<data-form>" e il <form> vuoto lo crea questo script in fondo alla pagina (così lo
     snippet può stare anche dentro un altro modulo, come nella landing JVC dentro il modulo d'acquisto);
   · campi a comparsa (azienda, spedizione, permuta): già nell'HTML, qui si tolgono e rimettono hidden;
   · controllo dei campi prima dell'invio, coi messaggi nella lingua della pagina (data-t-* dello snippet); senza prodotto il messaggio
     è obbligatorio;
   · POST JSON alla function richiestaSito coi nomi dello schema + sito_web (trappola) + t_compilazione_ms (dal primo campo toccato);
     tipo dallo snippet; dettagli solo per info_prodotto con un prodotto (gli altri tipi: nessun campo specifico, decisione 24/10/2026);
   · il prodotto viene dalla pagina: la variante è quella scelta nel modulo d'acquisto della scheda, se c'è;
   · (24/10/2026) dopo un invio riuscito la radice manda l'evento «bvm-richiesta:inviata» (detail: id, tipo), che sale nella pagina;
     ricevendo «bvm-richiesta:azzera» il modulo torna vuoto e visibile (lo usa il pannello Scrivici alla riapertura). */
(function () {
  'use strict';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var caricata = Date.now();

  function avvia(root) {
    if (root.__bvmRichiesta) return; root.__bvmRichiesta = true;
    var fid = root.getAttribute('data-form');
    var form = document.getElementById(fid);
    if (!form) { form = document.createElement('form'); form.id = fid; form.noValidate = true; form.hidden = true; document.body.appendChild(form); }
    var modulo = root.querySelector('[data-bvm-richiesta-modulo]');
    var boxErrori = root.querySelector('[data-bvm-richiesta-errori]');
    var ok = root.querySelector('[data-bvm-richiesta-ok]');
    var invia = root.querySelector('[data-bvm-richiesta-invia]');
    var conProdotto = root.getAttribute('data-con-prodotto') === 'true';
    var tipo = root.getAttribute('data-tipo') || 'contatto';
    var t = function (k) { return root.getAttribute('data-t-' + k) || ''; };
    var campo = function (n) { return root.querySelector('[name="' + n + '"]'); };
    var valore = function (n) { var c = campo(n); return c && c.value != null ? String(c.value).trim() : ''; };
    var scelto = function (n) { var c = root.querySelector('input[name="' + n + '"]:checked'); return c ? c.value : ''; };
    var spuntato = function (n) { var c = campo(n); return !!(c && c.checked); };
    var primoTocco = 0;
    root.addEventListener('focusin', function () { if (!primoTocco) primoTocco = Date.now(); });

    // campi a comparsa: un radio con data-bvm-richiesta-mostra="x" mostra il blocco data-bvm-richiesta-blocco="x" quando è scelto
    function aggiornaBlocchi() {
      root.querySelectorAll('input[type=radio][data-bvm-richiesta-mostra]').forEach(function (r) {
        var nome = r.getAttribute('data-bvm-richiesta-mostra'); if (!nome) return;
        var b = root.querySelector('[data-bvm-richiesta-blocco="' + nome + '"]'); if (b) b.hidden = !r.checked;
      });
    }
    root.addEventListener('change', function (e) { if (e.target.matches('input[type=radio]')) aggiornaBlocchi(); });
    aggiornaBlocchi();
    var testoInvia = invia.textContent;
    // il modulo torna vuoto: form.reset() rimette i valori iniziali di tutti i campi legati al form (anche i dati del cliente collegato)
    root.addEventListener('bvm-richiesta:azzera', function () {
      form.reset(); primoTocco = 0; mostraErrori([], []); aggiornaBlocchi();
      invia.disabled = false; invia.textContent = testoInvia; ok.hidden = true; modulo.hidden = false;
    });

    // la variante scelta nella scheda (modulo d'acquisto del tema), altrimenti ?variant= nell'indirizzo, altrimenti quella dello snippet
    function variante() {
      var f = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (f && /^\d+$/.test(String(f.value))) return String(f.value);
      var m = /[?&]variant=(\d+)/.exec(location.search); if (m) return m[1];
      return root.getAttribute('data-variant-id') || '';
    }

    function mostraErrori(messaggi, campiSbagliati) {
      root.querySelectorAll('[aria-invalid]').forEach(function (c) { c.removeAttribute('aria-invalid'); });
      (campiSbagliati || []).forEach(function (n) { var c = campo(n); if (c && c.setAttribute) c.setAttribute('aria-invalid', 'true'); });
      if (!messaggi.length) { boxErrori.hidden = true; boxErrori.textContent = ''; return; }
      boxErrori.textContent = '';
      if (messaggi.length === 1) boxErrori.textContent = messaggi[0];
      else {
        var p = document.createElement('p'); p.style.margin = '0'; p.textContent = t('err-campi'); boxErrori.appendChild(p);
        var ul = document.createElement('ul'); messaggi.forEach(function (x) { var li = document.createElement('li'); li.textContent = x; ul.appendChild(li); }); boxErrori.appendChild(ul);
      }
      boxErrori.hidden = false;
      var primo = (campiSbagliati || []).map(campo).filter(function (c) { return c && c.focus; })[0];
      if (primo) primo.focus(); else boxErrori.scrollIntoView({ block: 'nearest' });
    }

    function controlla() {
      var m = [], c = [];
      if (!valore('nome')) { m.push(t('err-nome')); c.push('nome'); }
      if (!valore('cognome')) { m.push(t('err-cognome')); c.push('cognome'); }
      if (!EMAIL_RE.test(valore('email'))) { m.push(t('err-email')); c.push('email'); }
      if (scelto('tipo_cliente') === 'azienda' && !valore('ragione_sociale')) { m.push(t('err-ragione')); c.push('ragione_sociale'); }
      if (!conProdotto && !valore('messaggio')) { m.push(t('err-messaggio')); c.push('messaggio'); }
      if (scelto('spedizione') === 'si' && !valore('paese')) { m.push(t('err-paese')); c.push('paese'); }
      if (scelto('permuta') === 'si' && !(valore('permuta_marchio') && valore('permuta_modello'))) { m.push(t('err-permuta')); c.push(!valore('permuta_marchio') ? 'permuta_marchio' : 'permuta_modello'); }
      if (!spuntato('consenso_privacy')) { m.push(t('err-consenso')); c.push('consenso_privacy'); }
      return { messaggi: m, campi: c };
    }

    function dettagli() {
      if (!(conProdotto && tipo === 'info_prodotto')) return {};
      var permuta = scelto('permuta') === 'si';
      return {
        disponibilita: spuntato('disponibilita'), righe: [], note: '',
        spedizione: { si: scelto('spedizione') === 'si', paese: scelto('spedizione') === 'si' ? valore('paese') : '' },
        servizi: Array.prototype.map.call(root.querySelectorAll('input[name="servizi"]:checked'), function (x) { return x.value; }),
        permuta: permuta ? { marchio: valore('permuta_marchio'), modello: valore('permuta_modello'), eta: valore('permuta_eta'),
          imballi: spuntato('permuta_imballi'), documento: spuntato('permuta_documento'), garanzia: spuntato('permuta_garanzia') } : null,
      };
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var esito = controlla();
      if (esito.messaggi.length) { mostraErrori(esito.messaggi, esito.campi); return; }
      mostraErrori([], []);
      var dati = {
        tipo: tipo, prova: root.getAttribute('data-prova') === 'true',
        lingua: root.getAttribute('data-lingua'), mercato: root.getAttribute('data-mercato'), pagina_url: location.href.split('#')[0],
        product_id: conProdotto ? root.getAttribute('data-product-id') : null, variant_id: conProdotto ? variante() : null,
        handle: conProdotto ? root.getAttribute('data-handle') : null,
        shopify_customer_id: root.getAttribute('data-shopify-customer-id') || null,
        nome: valore('nome'), cognome: valore('cognome'), email: valore('email'), telefono: valore('telefono'),
        tipo_cliente: scelto('tipo_cliente') || 'privato', ragione_sociale: scelto('tipo_cliente') === 'azienda' ? valore('ragione_sociale') : '',
        preferenza_contatto: 'email',
        messaggio: valore('messaggio'),
        dettagli: dettagli(),
        consenso_privacy: spuntato('consenso_privacy'),
        sito_web: valore('sito_web'),
        t_compilazione_ms: Date.now() - (primoTocco || caricata),
      };
      var testoBottone = invia.textContent; invia.disabled = true; invia.textContent = t('invio');
      fetch(root.getAttribute('data-url'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(dati) })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { stato: r.status, j: j }; }); })
        .then(function (x) {
          if (x.stato === 200 && x.j.ok) {
            modulo.hidden = true; ok.hidden = false; ok.focus();
            root.dispatchEvent(new CustomEvent('bvm-richiesta:inviata', { bubbles: true, detail: { id: x.j.id || null, tipo: tipo } }));
            return;
          }
          invia.disabled = false; invia.textContent = testoBottone;
          if (x.stato === 429) { mostraErrori([t('err-troppe')], []); return; }
          // 400: i messaggi della function sono in italiano; nelle altre lingue resta il messaggio generico
          if (x.stato === 400 && x.j && x.j.errori && x.j.errori.length) { mostraErrori(root.getAttribute('data-lingua') === 'it' ? x.j.errori : [t('err-campi')], []); return; }
          mostraErrori([t('err-invio')], []);
        })
        .catch(function () { invia.disabled = false; invia.textContent = testoBottone; mostraErrori([t('err-invio')], []); });
    });
  }

  function tutte() { document.querySelectorAll('[data-bvm-richiesta]').forEach(avvia); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tutte); else tutte();
})();
